let storage = {
  saveToken: function(logo, logoBuiran, name, nameRestaurant, token, url) {
    sessionStorage.setItem("br-ca-logo", logo);
    sessionStorage.setItem("br-ca-logoBuiran", logoBuiran);
    sessionStorage.setItem("br-ca-name", name);
    sessionStorage.setItem("br-ca-nameRestaurant", nameRestaurant);
    sessionStorage.setItem("br-ca-token", token);
    sessionStorage.setItem("br-ca-url", url);
  },
  loadToken: function() {
    var data = sessionStorage.getItem("br-ca-token");
    return data;
  },
  loadLogo: function() {
    var data = sessionStorage.getItem("br-ca-logo");
    return data;
  },
  loadLogoBuiran: function() {
    var data = sessionStorage.getItem("br-ca-logoBuiran");
    return data;
  },
  loadName: function() {
    var data = sessionStorage.getItem("br-ca-name");
    return data;
  },
  loadNameRestaurant: function() {
    var data = sessionStorage.getItem("br-ca-nameRestaurant");
    return data;
  },
  loadURL: function() {
    var data = sessionStorage.getItem("br-ca-url");
    return data;
  },
  loadAuthenticated: function() {
    var data = sessionStorage.getItem("br-ca-isAuthenticated");
    return data;
  },
  sessionExpiresAt: function() {
    try { const payload = JSON.parse(atob(this.loadToken().split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))); return Number.isFinite(payload.exp) ? payload.exp * 1000 : 0; }
    catch (error) { return 0; }
  },
  saveAuthenticated: function(value) {
    sessionStorage.setItem("br-ca-isAuthenticated", value);
  },
  removeItemsSessionStorage: function() {
    Object.keys(sessionStorage).filter(key => key.startsWith('br-ca-')).forEach(key => sessionStorage.removeItem(key));
    window.dispatchEvent(new Event('brb-session-ended'));
  },
};
export default storage;
